import {
  Box,
  Button,
  DialogTitle,
  DropdownSeparator,
} from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import BranchLeaf from '@/assets/illustrations/branch-leaf.svg?react'
import noiseImage from '@/assets/images/noise.png'
import { largeTabletAndDown } from '@/styles/media'

export const UpdatePayoutMethodButton = styled(Button).attrs({
  variant: 'pillFilled',
  color: 'tertiary',
})`
  margin-top: -${({ theme }) => theme.space[4]};
  z-index: 2;
`
export const PayoutSidebarContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $gap: 6,
  $align: 'initial',
})``

export const PayoutMethodInfoContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $justify: 'center',
})``

export const PayoutMethodContainer = styled(PayoutSidebarContainer).attrs({
  $pb: 6,
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  ${largeTabletAndDown(css`
    border-bottom: none;
    padding-bottom: 0;
  `)}
`

export const Separator = styled(DropdownSeparator)`
  width: 100%;
  margin-top: -${({ theme }) => theme.space[0.5]};
`
const phoneContainerPadding = '5px'
export const PhoneContainer = styled(Box).attrs({
  $fullWidth: true,
  $display: 'flex',
  $direction: 'column',
  $align: 'stretch',
})`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => `${theme.space[12]} ${theme.space[12]} 0 0`};

  max-width: 280px;
  min-height: 175px;

  box-shadow:
    0px -1.4px 5.61px -1.4px rgba(53, 52, 68, 0.1),
    0px -1.4px 2.8px -1.4px rgba(53, 52, 68, 0.06);
  background-color: black;
  padding: ${phoneContainerPadding} ${phoneContainerPadding} 0;
`

export const StyledBranchLeaf = styled(BranchLeaf)`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 5px;
  min-width: 210px;
`

export const PhoneContent = styled(Box).attrs({
  $flex: 1,
  $px: 3,
  $display: 'flex',
  $direction: 'column',
  $align: 'stretch',
})`
  position: relative;
  border-radius: ${({ theme }) =>
    `calc(${theme.space[12]} - ${phoneContainerPadding}) calc(${theme.space[12]} - ${phoneContainerPadding}) 0 0`};

  background: rgba(31, 31, 31, 1);
  overflow: hidden;

  &&:before {
    content: '';
    position: absolute;
    top: 0%;
    right: 0%;
    width: 100%;
    height: 100%;
    background: url(${noiseImage}) repeat;
    opacity: 0.25;
    mix-blend-mode: color-burn;
  }
`

export const PhoneContentInner = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $justify: 'space-between',
  $align: 'initial',
  $gap: 2,
  $fullWidth: true,
  $flex: 1,
  $pt: 5,
})`
  max-width: 210px;
  margin: 0 auto;
  z-index: 1;
`

export const BackgroundGlow = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;

  &&:before {
    content: '';
    position: absolute;
    top: -20%;
    left: 40%;
    width: 100%;
    height: 100%;
    background: rgba(87, 238, 145, 1);
    filter: blur(40px);
    opacity: 0.8;
  }

  &&:after {
    content: '';
    position: absolute;
    top: 100%;
    left: -50%;
    width: 100%;
    height: 100%;
    background: rgba(0, 205, 77, 1);
    filter: blur(49px);
    opacity: 0.8;
  }
`

export const PhoneAppIconContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $justify: 'center',
  $align: 'center',
})`
  gap: 2px;
  align-self: flex-start;
`

export const PhoneCard = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $justify: 'center',
  $align: 'center',
  $p: 4,
})`
  border-radius: ${({ theme }) => `${theme.space[4]} ${theme.space[4]} 0 0`};
  background: ${({ theme }) => theme.colors.background};
  text-align: center;
`

export const AppFeaturesListContainer = styled(Box).attrs({ $px: 6, $py: 8 })`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.radii.lg};
`

export const LargeDialogTitle = styled(DialogTitle)`
  font-size: ${({ theme }) => theme.fontSizes['3xl']};
  line-height: 1.2;
`

export const DebitCardModalContentContainer = styled(Box)`
  position: relative;
  margin: -24px -24px -16px -16px;
`

export const DebitCardModalLoaderBackground = styled(Box)`
  position: absolute;
  inset: 0;
  background-color: ${({ theme }) => theme.colors.surface};
`
